import BevSafeText from '../bev-safe-text';

export const TitleWrapper = ({
	title,
	className,
	titleHTag = 'h1',
	asHtmlString = false,
}: {
	title: string;
	className?: string;
	titleHTag?: 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6';
	asHtmlString?: boolean;
}) => {
	const TitleTag = titleHTag;

	return asHtmlString ? (
		<TitleTag className={className} dangerouslySetInnerHTML={{ __html: title }} />
	) : (
		<TitleTag className={className}>
			<BevSafeText>{title}</BevSafeText>
		</TitleTag>
	);
};
